import type { components } from './auto-gen-types'

type PlanDetails = components['schemas']['PlanDetails']
type PlanId = PlanDetails['plan_id']
type PlanFeature = PlanDetails['features'][number]

export type Plan = {
  plan_id: PlanId
  title: string
  interval: PlanDetails['interval']
  storage_size_bytes: number
  storage_files_length: number
  features: PlanFeature[]
  price: number
  hierarchy: number
  discount_percent: number
  popular: boolean
  discount_amount: number
  product_id?: string | null
  price_id?: string | null
}

export const calculateDiscountAmount = (plan: PlanDetails, all_plans: PlanDetails[]): number => {
  if (plan.interval !== 'annual') return 0

  const monthly_plan_id = plan.plan_id.replace('_annual', '_monthly')
  const monthly_plan = all_plans.find(candidate => candidate.plan_id === monthly_plan_id)
  return monthly_plan ? (monthly_plan.price * 12) - plan.price : 0
}

export const convertApiPlansToPlanArray = (api_response: { plans: PlanDetails[] }): Plan[] =>
  api_response.plans.map(plan => ({
    plan_id: plan.plan_id,
    title: plan.title,
    interval: plan.interval,
    storage_size_bytes: plan.storage_size_bytes,
    storage_files_length: plan.storage_files_length,
    features: plan.features,
    price: plan.price,
    hierarchy: plan.hierarchy,
    discount_percent: plan.discount_percent ?? 0,
    popular: plan.plan_id === 'standard_annual',
    discount_amount: calculateDiscountAmount(plan, api_response.plans),
    product_id: plan.product_id,
    price_id: plan.price_id
  }))
